import { Card, Table } from '@mui/joy';
import React from 'react';
import { Round } from '../models/round';

interface HoleListProps {
    currentRound?: Round;
}

const HoleList = ({ currentRound }: HoleListProps) => {

    return <Card variant="outlined">
        <Table borderAxis="xBetween" sx={{ '& tr > *:not(:first-child)': { textAlign: 'right' } }}>
            <thead>
            <tr>
                <th style={{ width: '20%' }}>Hole</th>
                <th>Score</th>
            </tr>
            </thead>
            <tbody>
            {
                currentRound?.player?.scores.map((hole) => (
                    <tr key={hole.hole}>
                        <th scope="row">{hole.hole}</th>
                        <td>{hole.score}</td>
                    </tr>
                ))
            }
            </tbody>
            <tfoot>
            <tr>
                <th>Total</th>
                <td>{currentRound?.player?.scores.reduce((acc, score) => acc + score.score, 0)}</td>
            </tr>
            </tfoot>
        </Table>

    </Card>;
};

export default HoleList;